// React.StrictMode renders components twice (on dev but not production) in order to detect any problems with the code and warn developer about them.
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { LicenseInfo } from '@mui/x-license-pro';

// project imports
import { Config } from 'utils/envConfig';
import AppRoutes from 'routes';
import store from 'features';
import ThemeCustomization from 'themes';
import { ConfigProvider } from 'contexts/ConfigContext';
import CrashFallbackProvider from 'views/pages/maintenance/CrashFallback/CrashFallbackProvider';
import Snackbar from 'components/assets/Snackbar';
import { KeycloakProvider } from 'contexts/KeycloakContext';
import { SseProvider } from 'utils/sse/SseContext';
import { MarketDayContextProvider } from 'utils/marketPeriods/MarketPeriodsContext';

LicenseInfo.setLicenseKey(
  '0aad4427a58cf022155f5beb57d14ae6Tz04MDI4OCxFPTE3MzM3NDkzMzgwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI='
);

function App() {
  return (
    <KeycloakProvider>
      <Provider store={store}>
        <ConfigProvider>
          <SseProvider>
            <ThemeCustomization>
              <MarketDayContextProvider>
                <Router basename={`${Config.baseUrl}`}>
                  <CrashFallbackProvider>
                    <>
                      <AppRoutes />
                      <Snackbar />
                    </>
                  </CrashFallbackProvider>
                </Router>
              </MarketDayContextProvider>
            </ThemeCustomization>
          </SseProvider>
        </ConfigProvider>
      </Provider>
    </KeycloakProvider>
  );
}

export default App;
